import 'magnific-popup';

jQuery(function ($) {
  $(window).on('load scroll', function () {
    var mv_height = $('.p-highschool__mv').outerHeight(true);
    var header_height = $('.js-logo-scroll').outerHeight(true);
    if($(window).scrollTop() > mv_height - (header_height * 2)) {
      $('.js-logo-scroll').addClass('is_scroll');
    } else {
      $('.js-logo-scroll').removeClass('is_scroll');
    }
  });

  $('.js-taglist li a').on('click', function () {
    $('.js-taglist li a').removeClass('is_active');
    $(this).addClass('is_active');
    var tag = $(this).attr('data-tag');
    var txt = $(this).text();
    $('.p-highschool__tag__btn').text(txt);
    $('.p-highschool__tag__btn').attr('data-tag', tag);
    if(tag === 'all') {
      $('.p-highschool__questionList li').show();
    } else {
      $('.p-highschool__questionList li').hide();
      $('.p-highschool__questionList li[data-tag="' + tag + '"]').show();
    }
  });

  if($('.popup-modal').length > 0) {
    $('.popup-modal').magnificPopup({
      type: 'inline',
      preloader: false,
      showCloseBtn: true,
      fixedContentPos: true,
      closeBtnInside: true,
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      callbacks: {
        open: function() {
          $('.main').addClass('is_popup_open');
        },
        close: function() {
          $('.main').removeClass('is_popup_open');
        }
      }
    });
  }

});
